import { Component, OnInit, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private cookieService: CookieService) {}

  ngOnInit(): void {
    if (isDevMode()) {
      console.log('👋 Development!');
    } else {
      console.log('💪 Production!');
    }
    if (this.cookieService.get('LOGIN_TOKEN').toString() != 'loggedIn') {
      this.router.navigate(['login']);
    }
  }
  title = 'xamar-daye';
}
